import { Routes as BrowserRoutes, Route } from "react-router";
import Home from "./home";
import Select from "./select";

export default function Warehouse(){
    return(
    <BrowserRoutes>

        {/* Select */}
        <Route path="/" element={<Select />} />

        {/* Home */}
        <Route path="/:id/*" element={<Home />} />

        
    </BrowserRoutes>
    )
}